module.exports = __webpack_public_path__ + "img/zx.680f5459.png";